import api from './api';

// Dryft — daily OHIP property-config monitoring across many hotels.
// Phase 1: project CRUD + per-project hotel management (each hotel has its own OHIP credential).
const dryftService = {
    list: async (filters = {}) => {
        const params = new URLSearchParams();
        if (filters.partner_id) params.append('partner_id', filters.partner_id);
        if (filters.account_id) params.append('account_id', filters.account_id);
        if (filters.hotel_id) params.append('hotel_id', filters.hotel_id);
        if (filters.active !== undefined) params.append('active', filters.active);
        if (filters.search) params.append('search', filters.search);
        return api.get(`/dryft${params.toString() ? '?' + params.toString() : ''}`);
    },
    get: (id) => api.get(`/dryft/${id}`),
    create: (data) => api.post('/dryft', data),
    update: (id, data) => api.put(`/dryft/${id}`, data),
    remove: (id) => api.delete(`/dryft/${id}`),

    // Hotels attached to a project — each with its own OHIP credential.
    listHotels: (id) => api.get(`/dryft/${id}/hotels`),
    addHotel: (id, data) => api.post(`/dryft/${id}/hotels`, data),
    removeHotel: (id, hotelRowId) => api.delete(`/dryft/${id}/hotels/${hotelRowId}`),

    // Config catalog (SPOT) — groups → sub-areas → checks, used by the config-set picker.
    getCatalog: () => api.get('/dryft/catalog'),

    // Routes — a project is built from routes; each pairs a config set → a notification target (by id).
    getRoutes: (id) => api.get(`/dryft/${id}/routes`),
    // routes = [{ config_set_id, notification_target_id, active }]
    setRoutes: (id, routes) => api.put(`/dryft/${id}/routes`, { routes }),

    // Live dry-run — fetch the selected config sub-areas from OHIP now and preview the item counts.
    // payload = { marketplace_id, account_id, partner_id, hotel_id, credential, subarea_keys | config_set_id | dryft_id }
    dryRun: (payload) => api.post('/dryft/dryrun', payload),

    // Recent config changes detected by the scheduled snapshot job.
    getChanges: (id, limit = 100) => api.get(`/dryft/${id}/changes?limit=${limit}`),

    // ── Configuration Sets — reusable named subsets of OHIP config sub-areas ────
    listConfigSets: async (filters = {}) => {
        const params = new URLSearchParams();
        if (filters.partner_id) params.append('partner_id', filters.partner_id);
        if (filters.account_id) params.append('account_id', filters.account_id);
        if (filters.hotel_id) params.append('hotel_id', filters.hotel_id);
        if (filters.active !== undefined) params.append('active', filters.active);
        if (filters.search) params.append('search', filters.search);
        return api.get(`/dryft-config-set${params.toString() ? '?' + params.toString() : ''}`);
    },
    getConfigSet: (id) => api.get(`/dryft-config-set/${id}`),
    createConfigSet: (data) => api.post('/dryft-config-set', data),
    updateConfigSet: (id, data) => api.put(`/dryft-config-set/${id}`, data),
    removeConfigSet: (id) => api.delete(`/dryft-config-set/${id}`),

    // ── Notification Targets — reusable recipient groups (≤3 emails + 1 Teams) ──
    listNotificationTargets: async (filters = {}) => {
        const params = new URLSearchParams();
        if (filters.partner_id) params.append('partner_id', filters.partner_id);
        if (filters.account_id) params.append('account_id', filters.account_id);
        if (filters.hotel_id) params.append('hotel_id', filters.hotel_id);
        if (filters.active !== undefined) params.append('active', filters.active);
        if (filters.search) params.append('search', filters.search);
        return api.get(`/dryft-notification-target${params.toString() ? '?' + params.toString() : ''}`);
    },
    getNotificationTarget: (id) => api.get(`/dryft-notification-target/${id}`),
    createNotificationTarget: (data) => api.post('/dryft-notification-target', data),
    updateNotificationTarget: (id, data) => api.put(`/dryft-notification-target/${id}`, data),
    removeNotificationTarget: (id) => api.delete(`/dryft-notification-target/${id}`),
};

export default dryftService;
